// generated by parseCompaniesCsv.js
export const data = JSON.parse(`[
  {
    "companyName": "A Bunch of Short Guys",
    "focuses": "Animation, Game Development, Graphic Design",
    "positionTypes": [
      "Volunteers",
      "Members"
    ],
    "website": "https://www.abunchofshortguys.org/",
    "interviews": "No",
    "virtualTimes": "",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://storage.tally.so/private/abosg.jpg?id=WJYkGL&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IldKWWtHTCIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwMDU4ODY1Nn0.g6lNTeQCGt3hdMlttfQn10H1Jvfkom8hfWQDP8J0GBU&signature=47654fbe72cb7b2d0f4f8a8682c3d6e0282b4ec6482ea974072d2755b630b5dc"
  },
  {
    "companyName": "POWER Engineers",
    "focuses": "VR/AR Engineering Visualization",
    "positionTypes": [
      "Interns",
      "Full-time Employees"
    ],
    "website": "powereng.com",
    "interviews": "Yes",
    "virtualTimes": "",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://storage.tally.so/private/Logo.png?id=PRN5dd&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IlBSTjVkZCIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwMDU4ODY1Nn0.xGUGbPDmNDptW4u3U6_HctLAhn-4dBM1zBgTjuMsDv4&signature=e95615acbc0079136266ec55a7343aec40d769829bef0b3909d5ee7adf89c57d"
  },
  {
    "companyName": "AEM Creations",
    "focuses": "Animation, Web Development, 3D Game Support",
    "positionTypes": [
      "Interns",
      "Contract Workers",
      "Freelancers"
    ],
    "website": "https://www.aem2create.com/",
    "interviews": "No",
    "virtualTimes": "All Day",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://storage.tally.so/private/Logo_Full_Black.png?id=NqkMPQ&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ik5xa01QUSIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwMTM4MjE3NH0.19Yh8uOKO6_EFb60PGCGcro4Pyjx0CY3rDcG24tM-5Q&signature=b469c4b44ac3302f89440c866cccf8478461ea080f9e00641f72d1629eafd699"
  },
  {
    "companyName": "Overland Partners",
    "focuses": "architectural viz",
    "positionTypes": [
      "Full-time Employees",
      "Freelancers"
    ],
    "website": "www.overlandpartners.com",
    "interviews": "Yes",
    "virtualTimes": "",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://storage.tally.so/private/Overland-logo.jpg?id=Q17r0l&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IlExN3IwbCIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwMjk5OTYzMn0.O0hj0hNUFEEcDLLf0cTkcKgfORdddvuCKh7VIESP0GE&signature=0fb5c93bfb9ad868a9931e567b86e75b45d835b9beab0f665a8d938647abdb2e"
  },
  {
    "companyName": "Bluepoint Games",
    "focuses": "Game Development",
    "positionTypes": [
      "Interns"
    ],
    "website": "https://www.bluepointgames.com/",
    "interviews": "Yes",
    "virtualTimes": "All Day",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://storage.tally.so/private/Bluepoint_Games_logo.png?id=Rx2KO4&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IlJ4MktPNCIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwNTk1MDA4Nn0.FKgR_fnld3gnNrsBk1_gLngvXUUmZZENJEhm3OVFa_c&signature=79d2a8417bb64d9ea5083ce8cf4bd388d5fdde266c4be31871692e2719a5e839"
  },
  {
    "companyName": "Populous",
    "focuses": "Graphic Design",
    "positionTypes": [
      "Full-time Employees"
    ],
    "website": "https://populous.com",
    "interviews": "Yes",
    "virtualTimes": "",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://storage.tally.so/private/Populous.jfif?id=qLpje2&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6InFMcGplMiIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwNjEzNjc3Nn0.N0OyPyQXYLkf5eyWsrrCepgl-pW33BA4WOKR_riUQgQ&signature=cc0ceb0aaf3e7312c950991fdb511f04a53d2bfa04b0ede55369bb572554d198"
  },
  {
    "companyName": "Electronic Arts",
    "focuses": "Game Development",
    "positionTypes": [
      "Interns",
      "Full-time Employees"
    ],
    "website": "www.ea.com",
    "interviews": "No",
    "virtualTimes": "All Day",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://storage.tally.so/private/Electronic_Arts_wordmark_RGB_whitebackground.png?id=VGBYba&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IlZHQlliYSIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwNjU2NzM0NH0.oXFMQilSUXYstlK6aF93SKp_ffekcask_0zlt_Fe7GA&signature=2d3ec9509df655d1b5cf47e87960eb5d79dbf2a5041cb9a8aa38619cfa961d0f, https://storage.tally.so/private/Electronic_Arts_wordmark_RGB.png?id=Nr9YbG&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ik5yOVliRyIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwNjU2NzM0NH0.S7QzTXAs7XRcsuW-KUcL9wPH8MUh8gmBTjEfCFibJYU&signature=eb113e85e18786e2673e264a209e7d72b58fa2127ce5c15cd70678b7d5d747c1"
  },
  {
    "companyName": "Deloitte",
    "focuses": "Graphic Design, UX/UI",
    "positionTypes": [
      "Full-time Employees"
    ],
    "website": "https://www.deloitte.com/global/en.html",
    "interviews": "No",
    "virtualTimes": "1:00-1:30, 11:00-11:30, 11:30-12:00, 12:30-1:00, 1:30-2:00",
    "inPersonTimes": "",
    "logoUrlCheckString": "https://storage.tally.so/private/Deloitte_Logo.png?id=7qg8NA&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjdxZzhOQSIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwNjYzNTkxNn0.elR0VqVZ9WpOXzXHy1N5Frza6VbbtD8wfhE47iJ6shU&signature=38f4a6568aef448be84c73fa7f12fd6bcdf21e81c3a0f31782983355ce921c15"
  },
  {
    "companyName": "PBK Architects",
    "focuses": "Architectural Vizualization",
    "positionTypes": [
      "Interns",
      "Full-time Employees"
    ],
    "website": "https://pbk.com/",
    "interviews": "Yes",
    "virtualTimes": "",
    "inPersonTimes": "11:00-11:30, 11:30-12:00, 12:30-1:00, 1:00-1:30, 2:00-2:30, 3:00-3:30, 3:30-4:00, 1:30-2:00",
    "logoUrlCheckString": "https://storage.tally.so/private/PBK-LOGO-Vector.svg?id=EKoVGX&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IkVLb1ZHWCIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwNzI2MjEzOH0.Y3jLdkVTBcJS4PiH1Jv8sts7vQjVgco17Ts67dDg-EY&signature=ba14a4167f8fe3be88320a2f1793bd821cd062cdd53eec5c6be5bebb49acd55f"
  },
  {
    "companyName": "TRG",
    "focuses": "Graphic Design, Motion Graphics",
    "positionTypes": [
      "Interns",
      "Full-time Employees",
      "Part-Time Employees",
      "Freelancers"
    ],
    "website": "https://trg.agency/",
    "interviews": "No",
    "virtualTimes": "10:30-11:00, 10:00-10:30, 1:00-1:30, 1:30-2:00, 3:30-4:00, 3:00-3:30",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://storage.tally.so/private/TRG-logo.png?id=4QMO95&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjRRTU85NSIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwNzg0NDY0NX0.h6e0o0fyauBiWzca8RHMKmWqRQ-ZPoORkd55_2E-QdI&signature=7853ab9a20f46fff12a3f369208c67ee07eb74a6f0cb6617339114baa1043558"
  },
  {
    "companyName": "The Third Floor Inc.",
    "focuses": "Animation",
    "positionTypes": [
      "Full-time Employees"
    ],
    "website": "https://thethirdfloorinc.com/",
    "interviews": "No",
    "virtualTimes": "12:30-1:00, 1:00-1:30",
    "inPersonTimes": "",
    "logoUrlCheckString": "https://storage.tally.so/private/TTF-Logomark-highres.png?id=OaRMGY&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ik9hUk1HWSIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwODAyMjI3NX0.I1qze_eAMByr6bjwu3p6m7yMcJIXM7lS6LQsBX99yDc&signature=b0d178f6874dcc6a551a13cee88af942390224bc288fa3ada2518bfb9a2f07ee"
  },
  {
    "companyName": "HKS Inc",
    "focuses": "Architecture",
    "positionTypes": [
      "Interns",
      "Full-time Employees"
    ],
    "website": "www.hksinc.com",
    "interviews": "Yes",
    "virtualTimes": "",
    "inPersonTimes": "10:00-10:30, 10:30-11:00, 11:00-11:30, 11:30-12:00",
    "logoUrlCheckString": "https://storage.tally.so/private/HKS-Logo-Grey-Digital_N2_medium.jpg?id=a9Wq0v&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImE5V3EwdiIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwODAyMjk2MH0.BcLISRTudSCoycRYxbh2kCx78HpzClzM51sCjUJk74E&signature=2d08d174085ba2bb2191e92488e7746b92b48808ec472646c9da4159d731f997"
  },
  {
    "companyName": "Framestore",
    "focuses": "VFX and Immersive",
    "positionTypes": [
      "Interns"
    ],
    "website": "https://www.framestore.com/",
    "interviews": "No",
    "virtualTimes": "",
    "inPersonTimes": "10:00-10:30, 10:30-11:00, 11:00-11:30, 11:30-12:00, 12:30-1:00",
    "logoUrlCheckString": "https://storage.tally.so/private/LOGO_blue_RGB.png?id=YP2Axd&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IllQMkF4ZCIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwODAyNjI0NX0.W8mI6z7mG07i4UvWYP1VBjaVXncKQ-ZRBFzzV9ALGRQ&signature=2718c04f09084dc58d0b15dac9d289cb97519c0530d0877c0d161bbf13d0fcda"
  },
  {
    "companyName": "Cinevva",
    "focuses": "Game Development",
    "positionTypes": [
      "Interns",
      "Freelancers",
      "Volunteers",
      "Members",
      "Researchers"
    ],
    "website": "cinevva.com",
    "interviews": "Yes",
    "virtualTimes": "10:00-10:30, 12:30-1:00",
    "inPersonTimes": "",
    "logoUrlCheckString": "https://storage.tally.so/private/Colorful-Watercolor-Painting-Phone-Wallpaper.png?id=Kzq7PD&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ikt6cTdQRCIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwODQ4NDg0Mn0.C3sCasY7yw3rBaChztpheVoovOgYRPzLtsUD1dn2RG8&signature=915bcc33791eba9d285129e44178e1fce7b563efda361206952dc1365c5245cc"
  },
  {
    "companyName": "Audience Media Group",
    "focuses": "Graphic Design, Video Editing & Marketing",
    "positionTypes": [
      "Part-Time Employees"
    ],
    "website": "https://www.ataudience.com/",
    "interviews": "Yes",
    "virtualTimes": "10:30-11:00, 11:00-11:30, 11:30-12:00, 12:30-1:00, 2:00-2:30, 3:00-3:30, 3:30-4:00",
    "inPersonTimes": "",
    "logoUrlCheckString": "https://storage.tally.so/private/LogoWhite.png?id=W2GD4Q&accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IlcyR0Q0USIsImZvcm1JZCI6Im1KcFd5ZCIsImlhdCI6MTcwODU0ODI2NH0.RuG9XWUXb7o66JUnU4nXxMUxgPHzRCsazLFnjZL0RJs&signature=61ee3893a86aa15f73a47315c4c50aef6ca4c67c5e78bdfc785627ee6186a8b4"
  }
]`);
